<template>
    <div :class="count.length>1?'container multi':'container'">
        <!-- <span>子集条件</span> -->
        <div class="condition" v-if="count.length>1" @click="changeMode">{{type==0?$t('message.且'):$t('message.或')}}</div>
            <div class="header2">test...</div>

        <div v-for="(item,index) in count" :key='item.id+""+item.pid+Math.random()'>
            <childrenf :class="index%2==0?' otherc choose1':'choose1' "  :style="index==count.length-1?'margin-bottom:0':''" :count='count' :index='index' :id='item.id' @delete='removechild' ></childrenf>
        </div>
        <!-- <childrenf :class="index%2==0?' otherc choose1':'choose1' "  :style="index==count.length-1?'margin-bottom:0':''" :count='count' :index='index' :id='item.id' @delete='removechild' ></childrenf> -->
      </div>
</template>
<script>
import childrenf from '@/components/children/childrenf.vue'
export default {
    name:'father',
    components:{
        childrenf
    },
    props:['count','type'],
    methods:{
        removechild(index){
            this.$emit('deletechild',index)
        },
        changeMode(){
            this.$emit('changeMode')
        }
    }
}
</script>
<style  scoped>
.container{
    margin: 10px 0 10px 15px;
    /* background-color: #fff; */
    position: relative;
}
.header2{
    display: flex;
    justify-content: space-between;
    height: 30px;
    font-size: 18px;
    margin: 0 0 0 30px;
    padding: 6px 20px 6px 20px;
    background-color: #FAFAFA;
}
    .choose1{
        height: 60px;
        width: calc(100%-30px);
        display: flex;
        justify-content: space-between;
        font-size: 18px;
        padding: 10px 40px 10px 15px;
        margin: 0 0 15px 30px;
        background-color: #baece2;
    }
    .otherc{
        background-color: #9fd3f5;
    }
    .multi{
        border-left: 1px solid #ccc;
    }
    .multi::before{
        content: '';
        display: block;
        height: 1px;
        width: 20px;
        background-color: #ccc;
    }
    .multi::after{
        content: '';
        display: block;
        width: 20px;
        height: 1px;
        background-color: #ccc;
    }
    .last{
        margin-bottom: none;
    }
    .condition{
        position: absolute;
        padding: 3px;
        background-color: blue;
        color: #fff;
        font-weight: 700;
        border-radius: 3px;
        top: 50%;
        cursor: pointer;
        left: 0;
        transform: translate(-50%,-50%);
    }
</style>



// WEBPACK FOOTER //
// src/components/children/father.vue